<mat-form-field class="tag-input">
  <mat-label>Add Tags</mat-label>
  <mat-chip-grid #chipGrid aria-label="Enter fruits">
    @for (tag of tags(); track tag) {
    <mat-chip-row (removed)="remove(tag)" [editable]="true" (edited)="edit(tag, $event)"
      [aria-description]="'press enter to edit ' + tag">
      {{tag.includes('#') ? tag : '#'+tag }}
      <button matChipRemove [attr.aria-label]="'remove ' + tag">
        <mat-icon>cancel</mat-icon>
      </button>
    </mat-chip-row>
    }
    <input placeholder="New Tag..." [matChipInputFor]="chipGrid" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
      [matChipInputAddOnBlur]="addOnBlur" (matChipInputTokenEnd)="add($event)" [matAutocomplete]="auto"
      [(ngModel)]="currentTag" />
  </mat-chip-grid>
  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event);">
    @for (tag of filteredTags(); track tag) {
    <mat-option [value]="tag">{{tag}}</mat-option>
    }
  </mat-autocomplete>
</mat-form-field>